export const ADD_CONTEXT_PROPERTY = "ADD_CONTEXT_PROPERTY";
export const REMOVE_CONTEXT_PROPERTY = "REMOVE_CONTEXT_PROPERTY";
export const SET_CONTEXT_PROPERTIES = "SET_CONTEXT_PROPERTIES";
export const UPDATE_CONTEXT_PROPERTY = "UPDATE_CONTEXT_PROPERTY";

export function addContextProperty(contextProperty) {
    return dispatch => dispatch({
        type: ADD_CONTEXT_PROPERTY,
        contextProperty
    });
}

export function removeContextProperty(contextProperty) {
    return dispatch => dispatch({
        type: REMOVE_CONTEXT_PROPERTY,
        contextProperty
    });
}

export function setContextProperties(contextProperties) {
    return dispatch => dispatch({
        type: SET_CONTEXT_PROPERTIES,
        contextProperties
    });
}

export function updateContextProperty(name, property, value) {
    return dispatch => dispatch({
        type: UPDATE_CONTEXT_PROPERTY,
        name,
        property,
        value
    });
}